<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

import { authComputed } from '@state/helpers'
import { authProtectedRoutes } from '@routes'

export default {
  components: {},
  props: {
    mode: {
      type: String,
      default: 'vertical',
    },
  },
  data() {
    return {
        menuItems: authProtectedRoutes,
        isAdmin: false,
        isCompany: false,
        isPartner: false
    }
  },
  computed: {
      ...authComputed,
      session_user_item(){
          let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
          let user = session.user ? session.user : null;
          return user;
      },
  },
  mounted: function() {

    if(this.session_user_item && this.session_user_item.role === 'administrator'){
        this.isAdmin = true;
    }
    if(this.session_user_item && this.session_user_item.type === 'partner'){
        this.isPartner = true;
    }
    if(this.session_user_item && this.session_user_item.iscompany){
      if(this.session_user_item.iscompany === 'false') {
          this.isCompany = false;
      }
      if(this.session_user_item.iscompany === 'true') {
          this.isCompany = true;
      }
    }

    // eslint-disable-next-line no-unused-vars
    var menuRef = null

    if (this.mode === 'horizontal') {
      menuRef = new MetisMenu('#side-menu').on('shown.metisMenu', function(
        event
      ) {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement)
            window.removeEventListener('click', menuClick)
          }
        })
      })
    } else {
      menuRef = new MetisMenu('#side-menu')
    }

    let links = document.getElementsByClassName('side-nav-link-ref')
    let matchingMenuItem = null

    for (let i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].getAttribute('data-path')) {
            matchingMenuItem = links[i]
            break;
        }
    }

    const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active'
    const dropdownActiveClass =
      this.mode === 'horizontal' ? 'active' : 'mm-show'

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      if (parent) {
        parent.classList.add(activeClass)
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.add(dropdownActiveClass)
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add(activeClass)
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add(dropdownActiveClass)
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add(activeClass)
      }
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.$parent.toggleMenu()
    },
    nav(route){
        this.toggleMenu();
        this.$router.push({ path: route});
    },
    hasItems(item) {
      return item && item.children !== undefined
        ? item.children.length > 0
        : false
    },
  },
}
</script>

<template>
    <ul id="side-menu" class="metismenu">
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/dashboard')" data-path="/account/dashboard" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-chart-pie-alt"></i><span>Дашборд</span>
            </a>
        </li>

        <li v-show="isAdmin || isCompany" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/companies')" data-path="/account/companies" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-suitcase"></i><span>Компании</span>
            </a>
        </li>

        <li v-show="isAdmin || isCompany || isPartner" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/users')" data-path="/account/users" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-users-alt"></i><span>Пользователи</span>
            </a>
        </li>

        <li v-show="isAdmin || isCompany || isPartner" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/users/accounts')" data-path="/account/users/accounts" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-usd-square"></i><span>Аккаунты</span>
            </a>
        </li>

        <li v-show="!isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/pricing')" data-path="/account/pricing" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-calculator-alt"></i><span>Тарифы</span>
            </a>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/economy')" data-path="/account/economy" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-chart-line"></i><span>Экономика</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Боты</p>
            <a href="javascript:void(0)" @click="nav('/account/bots')" data-path="/account/bots" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-robot"></i><span>Мои боты</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/skills')" data-path="/account/skills" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-sitemap"></i><span>Сценарии</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/dictionaries')" data-path="/account/dictionaries" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-book-alt"></i><span>Словари</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/knowledge')" data-path="/account/knowledge" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-atom"></i><span>Базы знаний</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">CRM</p>

            <a
                href="javascript:void(0);"
                class="side-nav-link"
                style="font-size: 14px;"
            >
                <i class="feather uil uil-user-check"></i>Контакты
                <span class="menu-arrow"></span>
            </a>

            <ul class="nav-second-level">
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/contacts')" data-path="/account/contacts" class="side-nav-link side-nav-link-ref">
                        <span>Список контактов</span>
                    </a>
                </li>
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/contacts/categories')" data-path="/account/contacts/categories" class="side-nav-link side-nav-link-ref">
                        <span>Группы контактов</span>
                    </a>
                </li>
                <li v-show="isAdmin" class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/contacts/blacklist')" data-path="/account/contacts/blacklist" class="side-nav-link side-nav-link-ref">
                        <span>Черный список</span>
                    </a>
                </li>
            </ul>

        </li>

        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/tasks')" data-path="/account/tasks" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-clipboard-alt"></i><span>Задачи</span>
            </a>
        </li>
        <!--
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/dialogs')" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-comments-alt"></i><span>Диалоги</span>
            </a>
        </li>
        -->

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Статистика</p>
            <a href="javascript:void(0)" @click="nav('/account/finance/payin')" data-path="/account/finance/payin" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-money-withdrawal"></i><span>Платежи</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/finance/payout')" data-path="/account/finance/payout" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-graph-bar"></i><span>Расходы</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/calls')" data-path="/account/calls" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-phone-pause"></i><span>Звонки</span>
            </a>
        </li>

        <li v-show="isAdmin || isCompany" class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Документы</p>
            <a href="javascript:void(0)" @click="nav('/account/documents/bills')" data-path="/account/documents/bills" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-bill"></i><span>Счета на оплату</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Файлы</p>
            <a href="javascript:void(0)" @click="nav('/account/imports/contacts')" data-path="/account/imports/contacts" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-user-plus"></i><span>Импорт контактов</span>
            </a>
        </li>
        <li class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/reports')" data-path="/account/reports" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-file-copy-alt"></i><span>Отчеты</span>
            </a>
        </li>

        <li class="side-nav-title side-nav-item">
            <hr/>
            <p class="menu-title mb-0" style="margin-top: 20px">Настройки</p>
            <a href="javascript:void(0)" @click="nav('/account/integrations')" data-path="/account/integrations" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-share-alt"></i><span>Интеграции</span>
            </a>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/channels')" data-path="/account/channels" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-rss-alt"></i><span>Каналы коммуникаций</span>
            </a>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/languages')" data-path="/account/languages" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-comment-alt-share"></i><span>Языки коммуникаций</span>
            </a>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/actions')" data-path="/account/actions" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-processor"></i><span>Функции ботов</span>
            </a>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/servers')" data-path="/account/servers" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-server"></i><span>Серверы</span>
            </a>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a
                href="javascript:void(0);"
                class="side-nav-link"
                style="font-size: 14px;"
            >
                <i class="feather uil uil-cloud-computing"></i>Операторы услуг
                <span class="menu-arrow"></span>
            </a>

            <ul class="nav-second-level">
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/operators')" data-path="/account/operators" class="side-nav-link side-nav-link-ref">
                        <span>Операторы</span>
                    </a>
                </li>
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/operators/tariffs')" data-path="/account/operators/tariffs" class="side-nav-link side-nav-link-ref">
                        <span>Тарификация услуг</span>
                    </a>
                </li>
            </ul>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/products')" data-path="/account/products" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-cloud-share"></i><span>Услуги</span>
            </a>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a
                href="javascript:void(0);"
                class="side-nav-link"
                style="font-size: 14px;"
            >
                <i class="feather uil uil-map"></i>География
                <span class="menu-arrow"></span>
            </a>

            <ul class="nav-second-level">
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/countries')" data-path="/account/countries" class="side-nav-link side-nav-link-ref">
                        <span>Страны</span>
                    </a>
                </li>
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/regions')" data-path="/account/regions" class="side-nav-link side-nav-link-ref">
                        <span>Регионы</span>
                    </a>
                </li>
            </ul>
        </li>

        <li class="side-nav-title side-nav-item">
            <a
                href="javascript:void(0);"
                class="side-nav-link"
                style="font-size: 14px;"
            >
                <i class="feather uil uil-phone"></i>Телефония
                <span class="menu-arrow"></span>
            </a>

            <ul class="nav-second-level">
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/trunks')" data-path="/account/trunks" class="side-nav-link side-nav-link-ref">
                        <span>Транки</span>
                    </a>
                </li>
                <li class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/trunks/phones')" data-path="/account/trunks/phones" class="side-nav-link side-nav-link-ref">
                        <span>Телефонные номера</span>
                    </a>
                </li>
                <li v-show="isAdmin" class="side-nav-item">
                    <a href="javascript:void(0)" @click="nav('/account/phones/codes')" data-path="/account/phones/codes" class="side-nav-link side-nav-link-ref">
                        <span>Коды операторов</span>
                    </a>
                </li>
            </ul>
        </li>

        <li v-show="isAdmin" class="side-nav-title side-nav-item">
            <a href="javascript:void(0)" @click="nav('/account/tariffs')" data-path="/account/tariffs" class="side-nav-link side-nav-link-ref">
                <i class="feather uil uil-calculator-alt"></i><span>Тарифы</span>
            </a>
        </li>
    </ul>
</template>

<style>
    .side-nav-link .uil{
        margin-right: 12px !important;
    }
    #sidebar-menu > ul > li > a span {
        font-size: 14px;
    }
</style>